// extracted by mini-css-extract-plugin
export default {"clinicPinDistance":"clinicPinDistance_clinicPinDistance__s7Lxk"};